// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonMessages = {
  copied: "コピーしました",
  copyFailed: "コピーに失敗しました",
  loading: "読み込み中...",
  requestFailed: "リクエストに失敗しました。しばらくしてから再試行してください。",
  loadFailed: "読み込みに失敗しました",
  totalCount: "全 {count} 件",
  selectedCount: "{count} 件を選択中",
  selectedAllCount: "{count} 件を選択しました",
  selectedPartialCount:
    "先頭 {selected} 件を選択しました（現在の絞り込み対象は全 {total} 件で、超過分は未選択です）",
  idNumber: "ID #{id}",
} as const;
